import { RouterProvider } from "react-router-dom";
import useUser from "shared/welda/features/auth/hooks/useUser";
import useWeldaPortalRoutes from "shared/welda/routes/useWeldaPortalRoutes";

const AppRouter = () => {
  const { browserRouter, createRoutes } = useWeldaPortalRoutes();
  useUser(createRoutes);

  return <RouterProvider router={browserRouter} />;
};

export default AppRouter;
